import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.js";
import * as libLocation from "../lib/location.ts";

ApiServer["custom.accchangepassword"] = ApiServer.accchangepassword.prepare(function(){
  libLocation.goTo( INR.URL.PASSWORD_RESET_SUCCESS );
});
